export default __webpack_public_path__ + "static/media/gallery_02.c8946bee.jpg";